import { Box, Chip, Icon, Theme, Typography } from "@outschool/backpack";
import { faGlobe } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { timeZoneName } from "@outschool/time";
import startCase from "lodash/startCase";
import React from "react";

export default function AvailableTimesHeader({
  sectionCount,
  userTimeZone,
}: {
  sectionCount?: number;
  userTimeZone: string;
}) {
  const { t } = useTranslation(
    "client\\components\\detailPage\\availableTimes\\AvailableTimesHeader",
  );
  return (
    <Box
      flex
      sx={{
        justifyContent: "space-between",
        width: "100%",
        alignItems: "center",
        gap: "0.5em",
        flexWrap: "wrap",
        paddingBottom: "1em",
      }}
    >
      <Typography
        variant="h4"
        sx={(theme: Theme) => ({
          fontSize: theme.typography.pxToRem(24),
          fontWeight: 700,
          [theme.breakpoints.up("md")]: {
            display: "block",
          },
        })}
        id="availability"
      >
        {t`Available times`}
        {!!sectionCount && (
          <Typography
            sx={(theme: Theme) => ({
              fontSize: theme.typography.pxToRem(24),
              fontWeight: 400,
              [theme.breakpoints.down("md")]: {
                display: "block",
              },
              [theme.breakpoints.up("md")]: {
                marginLeft: "0.5em",
              },
            })}
          >
            ({t("{{sectionCount}} available", { sectionCount })})
          </Typography>
        )}
      </Typography>
      <Chip
        size="small"
        color="neutral"
        icon={<Icon icon={faGlobe} />}
        label={startCase(timeZoneName(userTimeZone))}
      />
    </Box>
  );
}
